<template>
  <div
    :class="classBindings"
    @click="toggle"
  >
    <div class="toggle-indicator"></div>
  </div>
</template>

<script>
export default {
  name: 'toggle',
  props: {
    value: Boolean,
  },
  methods: {
    toggle() {
      this.$emit('toggle');
    },
  },
  computed: {
    classBindings() {
      return {
        toggle: true,
        active: this.value,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle {
  cursor: pointer;
  width: 50px;
  padding: 5px;
  background: #7a81b0;
  border-radius: 25px;
  transition: background-color 500ms ease-out;

  &.active {
    background-color: #0f1c70;
    .toggle-indicator {
      transform: translateX(20px);
    }
  }

  &-indicator {
    width: 20px;
    height: 20px;
    background-color: #ffffff;
    border-radius: 20px;
    transition: transform 100ms ease-out;
  }
}
</style>
